













import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import NormalButton from '@/components/atom/button/NormalButton.vue';

@Component({
  components: {
    NormalButton,
  },
})
export default class AlertDialog extends Vue {
  @Prop({default: 'アラート'})
  private name!: string;
  @Prop({default: '340px'})
  private width!: string | number;
  @Prop()
  private message!: string | string[];

  @Emit('close-event')
  private アラートダイアログを閉じる(): void {
    this.$modal.hide(this.name);
  }

  private メッセージ(): string[] {
    if (typeof this.message === 'string') {
      return [this.message];
    }
    return this.message;
  }
}
